module.exports = __webpack_public_path__ + "img/chiku04.deeb54bb.png";